import * as types from './mutations-types';
import ESService from '../../../services/ESService';
import { logError } from '@/utils/loggerUtils';
import { API, graphqlOperation } from 'aws-amplify';
import { getNotificationPreferences } from '@/graphql/queries';
import { getCurUser } from '@/constants/fromLocalStorageConstants';
import {
  createNotificationPreferences,
  updateNotificationPreferences,
} from '@/graphql/mutations';

export const actions = {
  async fetchDbStats({ commit }, { dateSince, includeDocs = false } = {}) {
    commit(types.FETCH_DBSTATS_STARTED);
    try {
      const res = await ESService.getDatabaseStats({ dateSince, includeDocs });
      commit(types.FETCH_DBSTATS_SUCCESS, {
        numDocuments: res.data.num_documents,
        docs: res.data.docs,
      });
    } catch (e) {
      logError(e);
      commit(types.FETCH_DBSTATS_FAILURE, e);
    }
  },
  async fetchRssFeeds({ commit }, { dateTimeSince, includeFeeds = true } = {}) {
    commit(types.FETCH_RSSFEEDS_STARTED);
    try {
      const res = await ESService.getRssFeeds({ dateTimeSince, includeFeeds });
      commit(types.FETCH_RSSFEEDS_SUCCESS, {
        numRssUpdates: res.data.num_feeds,
        feeds: res.data.feeds,
      });
    } catch (e) {
      logError(e);
      commit(types.FETCH_RSSFEEDS_FAILURE, e);
    }
  },
  async fetchNotificationPreferences({ commit }) {
    commit(types.FETCH_PREFS_STARTED);
    try {
      // upsert on front end since backend will not handle this right now
      try {
        const res = await API.graphql(
          graphqlOperation(getNotificationPreferences, {
            id: getCurUser().email,
          })
        );
        commit(types.FETCH_PREFS_SUCCESS, {
          enabled: res.data.getNotificationPreferences.enabled,
          frequency: res.data.getNotificationPreferences.frequency,
        });
      } catch {
        const enabled = false;
        const frequency = 'WEEK';
        await API.graphql(
          graphqlOperation(createNotificationPreferences, {
            input: {
              id: getCurUser().email,
              enabled,
              frequency,
            },
          })
        );
        commit(types.FETCH_PREFS_SUCCESS, {
          enabled,
          frequency,
        });
      }
    } catch (e) {
      logError(e);
      commit(types.FETCH_PREFS_FAILURE, e);
    }
  },
  async updateNotificationPreferences(
    { commit },
    { enabled = false, frequency = 'WEEK' } = {}
  ) {
    commit(types.UPDATE_PREFS_STARTED);
    try {
      await API.graphql(
        graphqlOperation(updateNotificationPreferences, {
          input: {
            id: getCurUser().email,
            enabled,
            frequency,
          },
        })
      );
      commit(types.UPDATE_PREFS_SUCCESS, {
        enabled,
        frequency,
      });
    } catch (e) {
      logError(e);
      commit(types.UPDATE_PREFS_FAILURE, e);
    }
  },
};
